import { useMutation } from '@apollo/client';

import type {
  SendPasswordResetEmailMutation,
  SendPasswordResetEmailMutationVariables,
} from 'src/graphql/generated';
import { SEND_PASSWORD_RESET_EMAIL } from 'src/graphql/gql_mutations';

export const useSendPasswordResetEmail = () => {
  const [mutate, { data, loading, error }] = useMutation<
    SendPasswordResetEmailMutation,
    SendPasswordResetEmailMutationVariables
  >(SEND_PASSWORD_RESET_EMAIL);
  return { mutate, data, loading, error };
};
